import Box from '@mui/material/Box/Box'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'styles/colors'
import { ReactComponent as NextIcon } from '../../assets/arrow_close_logo.svg'
import { CardStandart } from '../../ui/CardStandart'
import { TypographyHeader } from '../../ui/typography/TypographyHeader'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'

const FeedingAnalyticsCard = () => {
	const navigate = useNavigate()
	return (
		<CardStandart
			onClick={() => navigate('feeding')}
			sx={{
				p: '24px',
				display: 'flex',
				flexDirection: 'column',
				gap: '24px',
				cursor: 'pointer',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<TypographyHeader>Аналитика кормления</TypographyHeader>
				<NextIcon
					stroke={COLORS.icon}
					style={{ transform: 'rotate(-90deg)' }}
				/>
			</Box>
			<TypographySecondary>
				Ежедневная, еженедельная, ежемесячная и годовая аналитика по состоянию
				кормового стола, качеству и количеству подталкиваний, динамике
				потребления сухого вещества, а также рекомендации системы.
			</TypographySecondary>
		</CardStandart>
	)
}

export default FeedingAnalyticsCard
